<template>
  <div
    class="spinner-loader w-full h-full bg-white/100 flex items-center justify-center z-[9999] backdrop-blur-[4px]"
  >
    <div
      class="loader h-12 w-12 flex justify-center items-center aspect-square box-border relative animate-[spin_1s_linear_infinite]"
    >
      <img
        class="w-full h-full"
        :src="spinnerImg"
        alt="loading-spinner-image"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import spinnerImg from "~/assets/images/loading-spinner-primary.svg";
</script>
